(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avant-apres"] && !Shopify.designMode) return;
  try {
    
  // Charger Cocoen.js si pas déjà chargé
  if (!window.CocoenLoaded) {
    var cocoenScript = document.createElement('script');
    cocoenScript.src = 'https://cdn.jsdelivr.net/npm/cocoen@2.0.5/dist/cocoen.min.js';
    cocoenScript.onload = function () {
      document.querySelectorAll('.cocoen').forEach(function (el) {
        new Cocoen(el);
      });
    };
    document.head.appendChild(cocoenScript);
    window.CocoenLoaded = true;
  } else {
    document.querySelectorAll('.cocoen').forEach(function (el) {
      new Cocoen(el);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avis3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ozalo-portraits')) {
  customElements.define('ozalo-portraits', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ozpc__track');
      const navigation = this.querySelector('.ozpc__navigation');
      if (!navigation) return;
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const progress = this.querySelector('[data-progress]');
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        navigation.hidden = max < 2;
        previous.disabled = this.track.scrollLeft < 2;
        next.disabled = this.track.scrollLeft >= max - 2;
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const position = max > 0 ? Math.min(1, Math.max(0, this.track.scrollLeft / max)) : 1;
        progress.style.setProperty('--ozpc-progress', visible + (1 - visible) * position);
      };
      const move = direction => {
        const card = this.querySelector('[data-portrait]');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion() });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-portrait]');
        if (!card) return;
        this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 16, behavior: this.motion() });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ozalo-bestsellers')) {
  customElements.define('ozalo-bestsellers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.ozbs__track');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      const controls = this.querySelector('.ozbs__controls');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.current = this.querySelector('[data-current]');
      if (!controls || !this.cards.length) return;
      controls.hidden = false;
      this.mobile = matchMedia('(max-width: 749px)');
      this.index = 0;
      this.update = () => {
        if (!this.mobile.matches) return;
        const start = this.track.getBoundingClientRect().left + 16;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect().left - start);
          if (delta < distance) { distance = delta; this.index = index; }
        });
        this.current.textContent = this.index + 1;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.cards.length - 1;
      };
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-card]');
        if (card && this.mobile.matches) this.go(this.cards.indexOf(card));
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    go(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const left = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 16;
      this.track.scrollBy({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
